module.exports = __webpack_public_path__ + "static/media/e8.8645a86e.jpg";